import {
    faCircleInfo,
    faDownLeftAndUpRightToCenter,
    faDownload,
    faEdit,
    faEnvelope,
    faEye,
    faHandHoldingDollar,
    faMoneyBill,
    faMoneyCheckDollar,
    // faPhone,
    faPlus,
    faSms,
    faTrashAlt,
    // IconDefinition,
    faAdd,
    faUpload,
    faRefresh,
    faFileText
  
  
  } from "@fortawesome/free-solid-svg-icons";

  import {
    faBoxOpen,
    faChartLine,
    faFileExcel,
    faFilePdf,
    faHandshakeAngle,
    faIndianRupeeSign,
    faListCheck,
    faMagnifyingGlassChart,
    faMapMarkerAlt,
    faMobileScreenButton,
    faPaperclip,
    faPhone,
    faPlane,
    faSync,
    faTachometerAlt,
    faTasks,
    faTextWidth,
    faTruckLoading,
    faUser,
    faW,
    IconDefinition,
  } from "@fortawesome/free-solid-svg-icons";


export const icons: Map<String, IconDefinition> = new Map([
    ["fa-plus", faPlus],
    ["fa-file-text",  faFileText],
    ["fa-eye", faEye],
    ["fa-phone", faPhone], // Only one instance of faPhone is kept
    ["fa-circle-info", faCircleInfo],
    ["fa-move-to", faDownLeftAndUpRightToCenter],
    ["fa-hand-holding-dollar", faHandHoldingDollar],
    ["fa-money-check-pen", faMoneyCheckDollar],
    ["fa-money-bill", faMoneyBill],
    ["fa-edit", faEdit],
    ["fa-trash-alt", faTrashAlt],
    ["fa-download", faDownload],
    ["fa-envelope", faEnvelope],
    ["fa-whatsapp", faSms],
    ["fa-add", faAdd],
    ["fa-upload", faUpload],
    ["fa-refresh", faRefresh],
    ["faUser", faUser],
    ["faPaperclip", faPaperclip],
    ["faPlane", faPlane],
    ["fa-indian-rupee", faIndianRupeeSign],
    ["fa-handshake-angle", faHandshakeAngle],
    ["fa-mobile-screen-button", faMobileScreenButton],
    ["fa-tasks", faTasks],
    ["fa-text-width", faTextWidth],
    ["fa-map-marker-alt", faMapMarkerAlt],
    ["fa-sync", faSync],
    ["fa-truck-loading", faTruckLoading],
    ["fa-box-open", faBoxOpen],
    ["fa-file-pdf", faFilePdf],
    ["fa-chart-line", faChartLine],
    ["fa-tachometer-alt", faTachometerAlt],
    ["fa-file-excel", faFileExcel],
    ["fa-list-check", faListCheck],
    ["fa-w", faW],
    ["fa-chart-scatter", faMagnifyingGlassChart]
]
);